import {
  Box,
  Flex,
  Icon,
  Image,
  Link,
  Link as LinkUi,
  Text,
} from "@chakra-ui/react";
import One from "../img/1.png";
import React from "react";
import { RightIcon, RightLongArrow } from "./Icons";

const PerspectiveBox = ({ blogImg, title, link }) => {
  return (
    <Link
      href={link}
      _hover={{
        textDecor: "none",
      }}
    >
      <Box
        className="PerspectiveBox"
        p={{ md: 8, base: 4 }}
        borderRadius={{ md: "30px", base: 0 }}
        background={{ md: "white", base: "rgba(0, 0, 0, 0.20)" }}
        boxShadow={{ md: "0px 4px 30px 0px rgba(0, 0, 0, 0.15)", base: "none" }}
        transition={"all ease .5s"}
        _hover={{
          boxShadow: "-2px 0px 30px 0px rgb(0 0 0)",
        }}
      >
        <Image
          w={"100%"}
          src={blogImg}
          display={{ md: "block", base: "none" }}
        />
        <Flex
          gap={4}
          flexDir={{ md: "column", base: "row" }}
          justifyContent={"space-between"}
          alignItems={{ md: "start", base: "center" }}
        >
          <Text
            color={{ md: "inherit", base: "white" }}
            mt={{ md: 4, base: 0 }}
            h={{ md: "72px", base: "" }}
            fontSize={{ md: "2xl", base: "sm" }}
            noOfLines={2}
          >
            {title}
          </Text>
          <LinkUi
            href={link}
            display={{ md: "flex", base: "none" }}
            alignItems={"center"}
            color={"Teal"}
            justifyContent={"start"}
            mt={6}
            gap={2}
          >
            Read Article
            <Icon
              as={RightLongArrow}
              w={"20%"}
              sx={{
                path: {
                  fill: "Teal",
                },
              }}
            />
          </LinkUi>
          <LinkUi href={link}>
            <RightIcon
              sx={{
                line: {
                  stroke: "white",
                },
              }}
              display={{ base: "flex", md: "none" }}
            />
          </LinkUi>
        </Flex>
      </Box>
    </Link>
  );
};

export default PerspectiveBox;
